<template>
  <div class="products">
    <div
      v-for="(group, groupIndex) in optionGroups"
      :key="group.groupId"
      class="requiredInfo font-size-12"
    >
      <!-- 提示语 -->
      <div class="title flex items-center flex-start q-px-md" :class="{ errorTips: !group.isVerify }">
        <span bold class="q-mx-xs subTitle text-black">
          {{ group.groupName }}
        </span>
        <span
          v-if="group.minSelection > 1"
          class="q-mx-xs tips text-theme-gray"
        >
          {{
            $t('details.minSelect', {
              min: group.minSelection,
              max: group.maxSelection,
            })
          }}
        </span>
        <span v-else class="q-mx-xs tips text-theme-gray">
          {{ $t('details.maxSelect', [group.maxSelection]) }}
        </span>
        <span v-if="group.minSelection" class="q-mx-xs required">
          {{ $t('details.required') }}
        </span>
      </div>
      <div class="option bg-white">
        <q-list>
          <div
            v-for="(item, memberIndex) in group.members"
            :key="item.product.id"
            class="productOption"
            :class="{ errorTips: !item.isVerify }"
          >
            <q-item
              :disable="!item.isCanAdd && item.disable"
              class="q-px-md q-pb-xs m-status base-item"
              :class="{ selected: item.isCanAdd }"
            >
              <q-item-section avatar top class="no-padding">
                <q-checkbox
                  v-model="item.isCanAdd"
                  :disable="!item.isCanAdd && item.disable"
                  @input="handlerForceUpdate($event, groupIndex, memberIndex)"
                />
              </q-item-section>
              <!-- 单选多选的 数据 -->
              <q-item-section class="textBox q-ml-sm">
                <q-item-label class="font-size-16 row-name">
                  <div class="ellipsis-2-lines row-name-text">
                    <span v-if="item.bundleQuantity > 1">
                      ({{ item.bundleQuantity }} pcs)
                    </span>
                    {{ item.product.name }}
                  </div>
                  <div class="row-name-right">
                    <span
                      v-if="
                        item.isCanAdd &&
                        item.product.modifiers &&
                        showTips(item) &&
                        !item.optParams
                      "
                      class="right-tip"
                    >
                      <span v-if="item.isVerify">*</span>
                      <span v-else class="vertical-top">
                        <q-icon name="error" size="16px" />
                      </span>
                      <span class="q-ml-xs">{{
                        $t('details.pleaseSelect')
                      }}</span>
                    </span>
                    <div v-if="item.isCanAdd" class="row-name-price">
                      +
                      {{
                        $n(
                          (item.memberPrice + item.modifierPrice) *
                            (item.quantity || 1),
                          'currency',
                          'id-ID',
                        )
                      }}
                    </div>
                  </div>
                </q-item-label>
                <q-item-label align="between" class="q-pa-none base-item-r3">
                  <div class="modifier">
                    <template v-if="item.optParams">
                      <div
                        v-for="(opt, optInedx) in item.showName"
                        :key="`${opt}-${optInedx}`"
                        class="text-theme-gray"
                      >
                        . {{ opt.name }}
                      </div>
                    </template>
                    <div v-if="item.comment" break class="text-theme-gray">
                      {{ item.comment }}
                    </div>
                  </div>
                  <div v-if="item.isCanAdd" class="counter">
                    <q-btn
                      unelevated
                      round
                      :disabled="item.quantity < 1"
                      size="xs"
                      color="dark"
                      icon="remove"
                      @click="handleReduceNumber(item)"
                    />
                    <!-- <q-input
                      v-model.number="item.quantity"
                      type="number"
                      readonly
                      class="counterText"
                    /> -->
                    <span class="text">{{ item.quantity }}</span>
                    <q-btn
                      unelevated
                      round
                      :disabled="!item.product.inStock || item.disable"
                      size="xs"
                      color="dark"
                      icon="add"
                      @click="handleAddNumber(item)"
                    />
                  </div>
                </q-item-label>
                <q-item-label
                  v-if="!item.isCanAdd"
                  class="q-my-xs q-pt-xs"
                  caption
                >
                  <span>
                    +
                    {{
                      $n(
                        (item.memberPrice + item.modifierPrice) *
                          (item.quantity || 1),
                        'currency',
                        'id-ID',
                      )
                    }}
                  </span>
                </q-item-label>
              </q-item-section>
              <q-card-section v-if="item.isCanAdd" class="base-item-action">
                <div class="action-item" @click="onAddNotes(item, groupIndex)">
                  <i
                    class="iconfont"
                    :class="[item.comment ? 'dm-a-Pencilalt' : 'dm-a-Xcircle']"
                  />
                  {{
                    item.comment
                      ? $t('details.editNotes')
                      : $t('details.addNotes')
                  }}
                </div>
                <div
                  v-if="item.product.modifiers"
                  class="action-item"
                  @click="handlerSelectVariant(item, groupIndex, memberIndex)"
                >
                  <i
                    class="iconfont"
                    :class="[
                      item.optParams ? 'dm-a-Pencilalt' : 'dm-a-Xcircle',
                    ]"
                  />
                  {{
                    item.optParams
                      ? $t('details.editVariant')
                      : $t('details.selectVariant')
                  }}
                </div>
              </q-card-section>
            </q-item>
          </div>
        </q-list>
      </div>
    </div>
    <Dialog
      v-model="showSelect"
      :product="curProduct"
      :max="insideMax"
      :min="insideMin"
      @getQuantity="changeCurQuantity"
      @getParams="getOptParams"
    />
    <CommentDialog :value="activeComment" @input="onConfirmComment" />
  </div>
</template>

<script>
import _ from 'lodash';
import { expandArr } from 'src/utils/loadsh';
import { verify } from './units';
import Dialog from './OptiDialog.vue';
import CommentDialog from './CommentDialog.vue';
import { isDef } from '../../../utils/base';

export default {
  components: { Dialog, CommentDialog },
  model: {
    prop: 'optionParams',
    event: 'getOptiParams',
  },
  props: {
    original: {
      type: Array,
      default: () => {},
    },
    optionParams: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      optionGroups: [],
      showSelect: false,
      curProduct: {},
      globalGroupIndex: 0,
      globalMemberIndex: 0,
      insideMax: 0,
      insideMin: 0,
      activeComment: {
        productId: '',
        comment: '',
        groupIndex: 0,
      },
    };
  },
  watch: {
    original: {
      handler(val) {
        if (!_.isEmpty(val)) {
          // 克隆数据 以便改动
          this.optionGroups = _.cloneDeep(val);
          this.optionGroups.forEach((group) => {
            group.members.forEach((item) => {
              item.bundleQuantity = _.cloneDeep(item.quantity) || 1;
              item.isCanAdd = false;
              item.disable = false;
              item.quantity = 0;
              item.modifierPrice = 0;
              item.isVerify = true;
              if (item.bundleQuantity > group.maxSelection) {
                item.disable = true;
              }
            });
          });
        }
      },
      immediate: true,
      deep: true,
    },
    optionGroups: {
      handler(val) {
        if (!_.isEmpty(val)) {
          const params = [];
          val.forEach((group) => {
            const groupObj = {
              packageGroupId: group.groupId,
              items: [],
            };
            const { maxSelection: max } = group;
            let sum = 0;
            group.members.forEach((item) => {
              if (item.isCanAdd) {
                sum += item.quantity;
                const itemsObj = {
                  type: 'single',
                  productId: item.product.id,
                  quantity: item.quantity,
                  comment: item.comment,
                  modifiers: expandArr(item.optParams),
                };
                groupObj.items.push(itemsObj);
              }
              if (item.quantity < 1) {
                item.isCanAdd = false;
                delete item.showName;
                delete item.optParams;
                item.isVerify = true;
                if (item.product.modifiers) {
                  item.product.modifiers.forEach((modi) => {
                    delete modi.value;
                  });
                }
              }
            });
            group.members.forEach((item) => {
              const { inStock, inList, inService, inLive } = item.product || {};
              if (!inList || !inService || !inStock || !inLive) {
                item.disable = true;
              } else if (sum + item.bundleQuantity > max) {
                item.disable = true;
              } else if (sum >= max) {
                item.disable = true;
              } else {
                item.disable = false;
              }
              if (item.bundleQuantity > group.maxSelection) {
                item.disable = true;
              }
            });
            if (groupObj.items.length > 0) {
              params.push(groupObj);
            }
          });
          this.$emit('getOptiParams', params);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handlerForceUpdate(val, groupIndex, memberIndex) {
      const obj = this.optionGroups[groupIndex].members[memberIndex];
      obj.quantity = val ? obj.bundleQuantity : 0;
      obj.isCanAdd = val;
      if (!val) obj.comment = '';
    },
    handlerSelectVariant(val, groupIndex, memberIndex) {
      this.curProduct = val;
      this.globalGroupIndex = groupIndex;
      this.globalMemberIndex = memberIndex;
      // insideMax 弹窗内最大能添加多少
      const { maxSelection: max } = this.optionGroups[groupIndex];
      let sum = 0;
      this.optionGroups[groupIndex].members.forEach((item) => {
        sum += item.quantity;
      });
      this.insideMax = max - sum + val.quantity;
      this.showSelect = true;
    },
    handleAddNumber(item) {
      item.quantity += item.bundleQuantity;
    },
    handleReduceNumber(item) {
      item.quantity -= item.bundleQuantity;
      if (item.quantity === 0) {
        item.comment = '';
      }
    },
    changeCurQuantity(val) {
      const group = this.optionGroups[this.globalGroupIndex];
      const detail = group.members[this.globalMemberIndex];
      detail.quantity = val;
    },
    getOptParams(val) {
      const group = this.optionGroups[this.globalGroupIndex];
      const detail = group.members[this.globalMemberIndex];
      val.forEach((item, index) => {
        detail.product.modifiers[index].value = item;
      });
      const obj = expandArr(val);
      let price = 0;
      obj.forEach((item) => {
        price += item.price;
      });
      detail.modifierPrice = price;
      detail.optParams = val;
      detail.showName = obj;
      detail.isVerify = true;
      this.optionGroups.sort();
    },
    checkRequired() {
      const result = this.optionGroups.map((group) => {
        const { members = [] } = group;
        const groupResult = members.map((item) => {
          const { modifiers } = item.product;
          if (item.isCanAdd && modifiers) {
            item.isVerify = verify(modifiers);
            return verify(modifiers);
          }
          item.isVerify = true;
          return true;
        });
        return groupResult;
      });
      this.$forceUpdate();
      return result;
    },
    checkSelectNum() {
      const result = this.optionGroups.map((group) => {
        const { minSelection: min, groupName: name } = group;
        let sum = 0;
        group.members.forEach((item) => {
          if (item.isCanAdd) {
            sum += item.quantity;
          }
        });
        if (sum < min) {
          group.isVerify = false;
          this.$q.notify({
            message: this.$t('details.verifySelectNum', { name, min }),
            spinner: false,
            position: 'bottom',
            classes: 'glossy',
            type: 'ongoing',
            timeout: 1500,
          });
          return false;
        }
        return true;
      });
      return result;
    },
    showTips(detail) {
      const { modifiers } = detail.product;
      if (modifiers) {
        return modifiers.some((item) => item.min > 0);
      }
      return false;
    },
    onAddNotes(product, index) {
      this.activeComment = {
        comment: product.comment,
        productId: product.product.id,
        groupIndex: index,
      };
    },
    onConfirmComment(_comment) {
      const { comment, productId, groupIndex } = _comment;
      if (!isDef(groupIndex)) {
        this.activeComment = { productId: '', comment: '' };
        return;
      }
      this.optionGroups[groupIndex]?.members?.find((item) => {
        if (item.product.id === productId) this.$set(item, 'comment', comment);
        this.activeComment = { productId: '', comment: '' };
        return item.product.id === productId;
      });
    },
  },
};
</script>

<style lang="scss">
.products {
  .requiredInfo {
    .title {
      padding: 8px 16px;
      line-height: 24px;
    }
    .required {
      height: 16px;
      line-height: 16px;
      background: $primary;
      padding: 0 4px;
      border-radius: 2px;
      color: #ffffff;
    }
    .option {
      padding: 10px 0px 8px;
      .productOption {
        margin-bottom: 6px;
        padding: 0 12px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .errorTips {
        background: #fef2f2;
      }
      .textBox {
        justify-content: flex-start !important;
        // margin-top: 10px;
      }
      .q-item__section--avatar {
        min-width: unset;
      }
      .q-checkbox__inner {
        width: 22px;
        height: 22px;
        min-width: unset;
        .q-checkbox__bg {
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .productFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .counter {
        display: flex;
        justify-content: center;
        align-items: center;
        .q-btn {
          width: 20px;
          height: 20px;
          .q-btn__wrapper {
            min-width: unset;
            min-height: unset;
            width: 20px;
            height: 20px;
          }
          .q-icon {
            font-size: 16px;
          }
        }
        .counterText {
          .q-field__control {
            &:before {
              display: none;
            }
            height: 24px;
            width: 32px;
            input {
              color: $black;
              font-weight: bold;
              font-size: 16px;
              text-align: center;
              padding: 0;
            }
          }
        }
      }
      .select {
        text-decoration: underline;
      }
      .errTips {
        color: #ef4444;
        margin-top: 10px;
        span {
          vertical-align: middle;
        }
      }
    }
  }

  .productOption {
    position: relative;
    .base-item {
      &.selected {
        overflow: hidden;
        padding: 16px 16px 48px;
        border: 1px solid $border-color-3;
        border-radius: 8px;
      }
      &-r3 {
        display: flex;
        margin-top: 6px;
        .counter {
          margin-left: auto;
          align-self: flex-start;
          .text {
            min-width: 30px;
            text-align: center;
            font-weight: bold;
            font-size: 16px;
          }
        }
      }
      .row-name {
        display: flex;
        align-items: center;
        .row-name-right {
          margin-left: auto;
          text-align: right;
          .right-tip {
            display: inline-block;
            font-size: 12px;
            color: $negative;
            margin-bottom: 4px;
          }
        }
        .row-name-price {
          margin-left: auto;
          font-size: 12px;
          color: $grayFont;
        }
        .row-name-text {
          font-size: 14px;
          align-self: flex-start;
        }
      }
      &-action {
        display: flex;
        justify-content: space-around;
        padding: 0;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: $button-bg;
        border-top: solid 1px $border-color-3;
        font-weight: bold;
        .action-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          .iconfont {
            color: #6b7280;
            margin-right: 3px;
          }
        }
      }
    }
  }
}
</style>
